import useFilterFormContext from 'components/filters/useFilterFormContext';
import LeadSearchField from 'components/forms/domain/lead/LeadSearchField';
import { Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const AutomatedReviewLogsLeadFilter = () => {
  const { t } = useTranslation();
  const { searchFieldRef } = useFilterFormContext();

  return (
    <LeadSearchField
      placeholder={t('form.guestNameEmail')}
      name="lead"
      instanceRef={searchFieldRef}
      containerClassName="search-field"
      leftAddon={<Glyphicon glyph="search" />}
    />
  );
};

export default AutomatedReviewLogsLeadFilter;
